import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSelect,_vm._b({attrs:{"items":[{value:null,text:'מדידה רגילה'},'MNS','HTM',{value:'TEKEN',text:'תקן'}],"label":"MNS\\HTM\\תקן"},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'v-select',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }